import { useContext, useEffect, useRef, useState } from 'react';
import Style from "./style.module.css";
import LeftSidePopupLayout from '../../popup/modal-layout';
import { GlobalContext } from '../../../context/Context';
import { useApiCall } from '../../custom-hooks/api-call';
import Swal from 'sweetalert2'
import ChevronDownIcon from '../../icons/chevron-down';
import DataNotFound from '../../ui/loader/data-not-found';

const DynamicFilter = ({ onClose, onSave = () => { }, data, returnData = [], editingFilters, selectFilterName = "My Filter", saveFilter, apiUrl, saveFilterOff = false }) => {
  const [filters, setFilters] = useState([]);
  const [status, setStatus] = useState(false);
  const [departmentList, setDepartmentList] = useState([]);
  const { state } = useContext(GlobalContext);
  const apiCall = useApiCall();
  const [onSaveFilter, setOnSaveFilter] = useState(saveFilter);

  useEffect(() => {
    if (returnData?.length) {
      const merged = data.map(item => {
        const override = returnData.find(o => o.name === item.name);
        return override ? override : item;
      });
      setFilters(merged);
    } else {
      setFilters(data);
    }
    setDepartmentList(state?.getDropdowns?.departmentList);
  }, [data, returnData]);

  const closeFun = () => {
    setStatus(false);
    setTimeout(() => {
      onClose();
    }, 200);
  };

  const handleCheckboxToggle = (index) => {
    // console.log("filters", filters);
    const updated = [...filters];
      //  console.log("Index" , updated[index] );
    updated[index].isChecked = !updated[index].isChecked;
    setFilters(updated);
  };

  const handleValueChange = (index, e) => {
    const updated = [...filters];
    updated[index].value = e.target.value;
    setFilters(updated);
  };

  const handleBetweenChange = (index, pos, val) => {
    const updated = [...filters];
    const salaryRange = [...updated[index].value];
    salaryRange[pos] = val;
    updated[index].value = salaryRange;
    setFilters(updated);
  };

  const handleSubmit = () => {
    const formatted = filters
      .filter(f => f.isChecked)
      .map(f => ({
        ...f
      }))
      .filter(f => Array.isArray(f.value) ? f.value.length > 0 : f.value != '');
    const filterName = saveFilterName;
    onSave(formatted, filterName, editingFilter);
    closeFun();
  };

  const [editingFilter, setEditingFilter] = useState(editingFilters);
  const [saveFilterName, setSaveFilterName] = useState(selectFilterName);
  const [saveFilterID, setSaveFilterID] = useState(null);
  const [saveFilterIs, setSaveFilterIs] = useState(false);
  const [originalFilters, setOriginalFilters] = useState([]);
  const wrapperRef = useRef(null);

  const handleSaveFilter = async () => {
    const formatted = filters
      .filter(f => f.isChecked)
      .map(f => ({
        ...f
      }))
      .filter(f => Array.isArray(f.value) ? f.value.length > 0 : f.value !== '');

    if (formatted.length === 0) {
      Swal.fire('No filters selected', 'Please select and fill filters before saving.', 'warning');
      return;
    }

    // Original filter name if editing
    const originalName = editingFilter?.filterName || '';

    let confirmBtnText = editingFilter ? 'Updated' : 'Saved';

    const { value: filterName } = await Swal.fire({
      title: editingFilter ? 'Update filter name' : 'Enter filter name',
      input: 'text',
      inputValue: originalName,
      inputPlaceholder: 'Enter a name for this filter',
      showCancelButton: true,
      confirmButtonText: confirmBtnText,
      cancelButtonText: 'Cancel',
      inputValidator: (value) => {
        if (!value.trim()) {
          return 'Filter name is required';
        }
      },
      didOpen: (popup) => {
        const input = popup.querySelector('input');
        const confirmBtn = popup.querySelector('.swal2-confirm');

        input.addEventListener('input', () => {
          if (editingFilter) {
            // Check if input differs from original
            if (input.value.trim() !== originalName.trim()) {
              confirmBtn.textContent = 'Duplicate';
              confirmBtnText = 'Duplicate';
            } else {
              confirmBtn.textContent = 'Updated';
              confirmBtnText = 'Updated';
            }
          }
        });
      }
    });

    if (!filterName) {
      return; // Cancelled or empty input
    }

    try {
      const apiData = {
        api_url: apiUrl,
        filter_name: filterName.trim(),
        filters_json: formatted,
      };

      // If editing, send filter_id too
      if (editingFilter?.filterId) {
        apiData.filter_id = editingFilter.filterId;
      }

      await apiCall({ method: 'post', url: 'list-config/save-filters', data: JSON.stringify(apiData) });

      Swal.fire('Success', `Filter ${confirmBtnText} Successfully`, 'success');

      onSave(formatted, filterName.trim(), editingFilter);
      setEditingFilter(null);

    } catch (error) {
      console.warn('Error saving filter:', error);
      Swal.fire('Error', 'Failed to save filter. Please try again.', 'error');
    }
  };

  const handleDeletFilter = async (id) => {
    const result = await Swal.fire({
      title: 'Delete Filter?',
      text: " This filter will be removed permanently.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel',
      reverseButtons: true,
    });

    if (!result.isConfirmed) return;

    try {
      const apiData = JSON.stringify({ filter_id: id });
      await apiCall({ method: 'post', url: `list-config/delete-filter/${id}`, data: apiData });
      setOnSaveFilter(prevFilters => prevFilters.filter(f => f.id !== id));

      if (editingFilter?.filterId === id) {
        setEditingFilter(null);  // reset editingFilter if it was deleted
        const reset = filters.map(f => ({
          ...f,
          isChecked: false,
          value:
            f.field === 'search_by_salary' || f.field === 'search_by_joining_date'
              ? ['', '']
              : '',
          selectedOperator:
            f.field === 'search_by_salary'
              ? 'between'
              : f.field === 'search_by_joining_date'
                ? 'is'
                : 'contains',
        }));
        setFilters(reset);
        setSaveFilterName('My Filter');
        setSaveFilterID(null);
      }
      Swal.fire('Done!', 'Filter Deleted Successfully.', 'success');
    } catch (error) {
      console.warn("Error deleting filter:", error);
      Swal.fire('Error', 'Failed to delete filter. Please try again.', 'error');
    }
  };

  const handleSaveFilterChange = (rdata, filterName, filterId) => {
    const merged = data.map(item => {
      const override = rdata.find(o => o.name === item.name);
      return override ? override : item;
    });
    setFilters(merged);


    setFilters(merged);
    setOriginalFilters(JSON.parse(JSON.stringify(merged))); // deep copy
    setEditingFilter({ filterName, filterId });
    setSaveFilterName(filterName);
  };

  // Compare function to check if filters changed
  const isFiltersChanged = () => {
    return JSON.stringify(filters) !== JSON.stringify(originalFilters);
  };

  // Close dropdown if clicked outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setSaveFilterIs(false);
      }
    }

    if (saveFilterIs) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    // Cleanup
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [saveFilterIs]);

  return (
    <LeftSidePopupLayout popupStatus={status} className={Style.customize_modal}>
      <div className={Style.modal_header}>
        <h4>
          Table Filters
          <button onClick={closeFun} className={Style.close_btn}>
            <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
              <path d="M1.21143 0.596189L10.4038 9.78858M1.21143 9.78858L10.4038 0.596189" stroke="currentColor" strokeWidth="1.18236" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </h4>

        {
          !saveFilterOff && (
            <div className={Style.myFilter}>
              <div ref={wrapperRef} className={`${Style.myFilter_main} ${saveFilterIs ? Style.active : ''}`}>
                <h5 onClick={() => { setSaveFilterIs(!saveFilterIs) }}>
                  {saveFilterName}

                  <div className={Style.dropIcon}>
                    <ChevronDownIcon />
                  </div>
                </h5>

                {
                  saveFilterIs && (
                    <div className={Style.myFilter__wrap}>
                      {
                        onSaveFilter?.length ? (
                          onSaveFilter.map((ele, idx) => {
                            return (
                              <div
                                className={`${Style.myFilter__items} ${(saveFilterName == ele?.filter_name) ? Style.isActive : ''}`}
                                key={ele.id || idx}
                                onClick={() => { handleSaveFilterChange(ele?.config_filters, ele?.filter_name, ele?.id); setSaveFilterIs(false); setSaveFilterID(ele?.id) }}
                              >
                                <p>
                                  {ele.filter_name}
                                </p>
                              </div>
                            )
                          })
                        ) : <div
                          className={Style.myFilter__items}
                        >
                          <DataNotFound title={'Filter'} className={Style.noDataFound} />
                        </div>
                      }
                    </div>
                  )
                }
              </div>

              <div className="flex gap-1">
                <button
                  className={`${Style.myFilter_btn} ${Style.deleteBtn}`}
                  onClick={() => { handleDeletFilter(saveFilterID); }}
                  disabled={saveFilterID ? false : true}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                    <path d="M10.9333 5.93451C10.7263 5.93451 10.5586 6.09177 10.5586 6.2858V12.9251C10.5586 13.119 10.7263 13.2764 10.9333 13.2764C11.1403 13.2764 11.308 13.119 11.308 12.9251V6.2858C11.308 6.09177 11.1403 5.93451 10.9333 5.93451Z" fill="white" />
                    <path d="M6.5124 5.93451C6.30543 5.93451 6.1377 6.09177 6.1377 6.2858V12.9251C6.1377 13.119 6.30543 13.2764 6.5124 13.2764C6.71937 13.2764 6.88711 13.119 6.88711 12.9251V6.2858C6.88711 6.09177 6.71937 5.93451 6.5124 5.93451Z" fill="white" />
                    <path d="M3.28981 4.96558V13.6206C3.28981 14.1321 3.4899 14.6125 3.83943 14.9572C4.18735 15.3029 4.67154 15.4991 5.17827 15.4999H12.2678C12.7747 15.4991 13.2589 15.3029 13.6067 14.9572C13.9562 14.6125 14.1563 14.1321 14.1563 13.6206V4.96558C14.8511 4.79268 15.3013 4.16339 15.2084 3.49498C15.1153 2.82671 14.508 2.32681 13.789 2.32668H11.8706V1.88757C11.8728 1.51831 11.717 1.16373 11.4382 0.902867C11.1594 0.642147 10.7806 0.496966 10.3867 0.499985H7.05941C6.66553 0.496966 6.28673 0.642147 6.0079 0.902867C5.72906 1.16373 5.57332 1.51831 5.57552 1.88757V2.32668H3.65705C2.93809 2.32681 2.3308 2.82671 2.23771 3.49498C2.14476 4.16339 2.595 4.79268 3.28981 4.96558ZM12.2678 14.7974H5.17827C4.53761 14.7974 4.03922 14.2814 4.03922 13.6206V4.99646H13.4069V13.6206C13.4069 14.2814 12.9085 14.7974 12.2678 14.7974ZM6.32493 1.88757C6.32244 1.70465 6.39914 1.5286 6.53761 1.39947C6.67593 1.27035 6.86416 1.1994 7.05941 1.20256H10.3867C10.5819 1.1994 10.7702 1.27035 10.9085 1.39947C11.047 1.52846 11.1237 1.70465 11.1212 1.88757V2.32668H6.32493V1.88757ZM3.65705 3.02925H13.789C14.1616 3.02925 14.4635 3.31234 14.4635 3.66157C14.4635 4.0108 14.1616 4.29388 13.789 4.29388H3.65705C3.28454 4.29388 2.98258 4.0108 2.98258 3.66157C2.98258 3.31234 3.28454 3.02925 3.65705 3.02925Z" fill="white" />
                    <path d="M8.72236 5.93451C8.5154 5.93451 8.34766 6.09177 8.34766 6.2858V12.9251C8.34766 13.119 8.5154 13.2764 8.72236 13.2764C8.92933 13.2764 9.09707 13.119 9.09707 12.9251V6.2858C9.09707 6.09177 8.92933 5.93451 8.72236 5.93451Z" fill="white" />
                  </svg>
                </button>

                <button
                  className={`${Style.myFilter_btn}`}
                  onClick={handleSaveFilter}
                  disabled={
                    editingFilter
                      ? !isFiltersChanged() // disable if no changes
                      : filters.filter(f =>
                        f.isChecked &&
                        (f.field === 'search_by_salary'
                          ? f.value[0] || f.value[1]
                          : f.value)
                      ).length === 0
                  }
                >
                  {/* {editingFilter ? 'Update Filter' : 'Save Filter'} */}

                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M14.9302 3.9172L11.9302 1.1047C11.8835 1.06125 11.8281 1.02688 11.7671 1.00355C11.7062 0.980225 11.641 0.968401 11.5752 0.968758H1.5752C1.17737 0.968758 0.79584 1.11692 0.514535 1.38064C0.233231 1.64436 0.0751953 2.00205 0.0751953 2.37501V13.625C0.0751953 13.998 0.233231 14.3557 0.514535 14.6194C0.79584 14.8831 1.17737 15.0313 1.5752 15.0313H13.5752C13.973 15.0313 14.3546 14.8831 14.6359 14.6194C14.9172 14.3557 15.0752 13.998 15.0752 13.625V4.25001C15.0756 4.18832 15.063 4.12716 15.0381 4.07005C15.0132 4.01294 14.9765 3.961 14.9302 3.9172ZM9.5752 1.90626V4.71876H5.5752V1.90626H9.5752ZM3.5752 14.0938V10.8125C3.5752 10.6882 3.62787 10.569 3.72164 10.4811C3.81541 10.3931 3.94259 10.3438 4.0752 10.3438H11.0752C11.2078 10.3438 11.335 10.3931 11.4288 10.4811C11.5225 10.569 11.5752 10.6882 11.5752 10.8125V14.0938H3.5752ZM14.0752 13.625C14.0752 13.7493 14.0225 13.8686 13.9288 13.9565C13.835 14.0444 13.7078 14.0938 13.5752 14.0938H12.5752V10.8125C12.5752 10.4395 12.4172 10.0819 12.1359 9.81814C11.8546 9.55442 11.473 9.40626 11.0752 9.40626H4.0752C3.67737 9.40626 3.29584 9.55442 3.01454 9.81814C2.73323 10.0819 2.5752 10.4395 2.5752 10.8125V14.0938H1.5752C1.44259 14.0938 1.31541 14.0444 1.22164 13.9565C1.12787 13.8686 1.0752 13.7493 1.0752 13.625V2.37501C1.0752 2.25069 1.12787 2.13146 1.22164 2.04355C1.31541 1.95564 1.44259 1.90626 1.5752 1.90626H4.5752V4.71876C4.5752 4.9674 4.68055 5.20586 4.86809 5.38167C5.05563 5.55749 5.30998 5.65626 5.5752 5.65626H9.5752C9.84041 5.65626 10.0948 5.55749 10.2823 5.38167C10.4698 5.20586 10.5752 4.9674 10.5752 4.71876V1.90626H11.3702L14.0752 4.4422V13.625Z" fill="currentColor" />
                  </svg>
                </button>
              </div>
            </div>
          )
        }

        <h6 className={`${(saveFilterOff) ? 'pt-4' : ''}`}>Search By:</h6>
      </div>

      <div className={`${Style.modal_body} ${Style.filterBodyPopup}`}>
        {
          filters.filter(f => f.isChecked).length ? (
            <div className={`${Style.filter_item_wrapper} ${filters.filter(f => f.isChecked).length === filters.length ? Style.isAll : ""}`}>
              {filters.map((filter, index) => {
                return (
                  filter.isChecked && (
                    <div className={Style.filter_item} key={`Filter_item_${index}_1`}>
                      <div className={Style.filter_label}>
                        <label>
                          <input
                            type="checkbox"
                            checked={filter.isChecked}
                            onChange={() => handleCheckboxToggle(index)}
                          />
                          <b></b>
                          <span className='capitalize'>
                            {filter?.label ?
                              <>{filter?.label}</>
                              :
                              <>
                                {filter?.name?.includes("_") ? `${filter?.name?.replaceAll("_", " ")}` : filter?.name}
                              </>
                            }
                          </span>
                        </label>
                      </div>

                      <div className={Style.filter_OprationAera}>
                        <>
                          <div className={`${Style.filter_input} !w-[50%]`}>
                            <select
                              value={filter.selectedOpt}
                              onChange={(e) => {
                                const updated = [...filters];
                                updated[index].selectedOpt = e.target.value;
                                if (e.target.value === 'between') {
                                  updated[index].value = ['', '']; // reset for range inputs
                                } else {
                                  updated[index].value = ''; // single value input
                                }
                                setFilters(updated);
                              }}
                            >
                              <option value="is" disabled={!filter?.options?.includes("is")}>is</option>
                              <option value="contains" disabled={!filter?.options?.includes("contains")}>contains</option>
                              <option value="between" disabled={!filter?.options?.includes("between")}>between</option>
                              <option value="start_with" disabled={!filter?.options?.includes("start_with")}>Start with</option>
                              <option value="end_with" disabled={!filter?.options?.includes("end_with")}>End with</option>
                            </select>
                          </div>

                          {(filter?.selectedOpt == "between") ?
                            <div className={Style.date_range_wrapper}>
                              <div className={Style.filter_input}>
                                <input
                                  type={filter?.betweenType}
                                  value={filter.value[0] || ''}
                                  onChange={(e) => handleBetweenChange(index, 0, e.target.value)}
                                  placeholder={`Min ${filter?.label ? filter?.label : filter?.name?.includes("_") ? `${filter?.name?.replaceAll("_", " ")}` : filter?.name}`}
                                />
                              </div>
                              <div className={Style.filter_input}>
                                <input
                                  type={filter?.betweenType}
                                  value={filter.value[1] || ''}
                                  onChange={(e) => handleBetweenChange(index, 1, e.target.value)}
                                  placeholder={`Max ${filter?.label ? filter?.label : filter?.name?.includes("_") ? `${filter?.name?.replaceAll("_", " ")}` : filter?.name}`}
                                />
                              </div>
                            </div>
                            :
                            <div className={Style.filter_input}>
                              {(filter?.type == "dropdown") ?
                                <select value={filter.value} onChange={(e) => handleValueChange(index, e)}>
                                  <option value="" disabled>
                                    Select {filter?.label ? <>{filter?.label}</> : <> {filter?.name?.includes("_") ? `${filter?.name?.replaceAll("_", " ")}` : filter?.name}</>
                                    }
                                  </option>
                                  {
                                    (filter?.dropdown) ?
                                      filter?.dropdown.map((els, ids) => {
                                        return (
                                          <option value={els[filter?.dropdownVal]} key={ids}>{els[filter?.dropdownKey]}</option>
                                        )
                                      })
                                      :
                                      departmentList.map((els, ids) => {
                                        return (
                                          <option value={els?.title} key={ids}>{els?.title}</option>
                                        )
                                      })
                                  }
                                </select>
                                :
                                <input
                                  type={filter?.type}
                                  value={filter.value}
                                  onChange={(e) => handleValueChange(index, e)}
                                  placeholder={`${filter?.label ? filter?.label : filter?.name?.includes("_") ? `${filter?.name?.replaceAll("_", " ")}` : filter?.name}`}
                                />
                              }
                            </div>
                          }
                        </>
                      </div>
                    </div>
                  )
                )
              })}
            </div>
          ) : (
            null
          )
        }

        {
          filters.filter(f => !f.isChecked).length ? (
            <div className={Style.filter_label_tag_wrap}>
              {filters.map((filter, index) => {
                return (
                  !filter.isChecked && (
                    <div key={`FilterItem_${index}_2`} className={Style.filter_label_tag}>
                      <label>
                        <input
                          type="checkbox"
                          checked={filter.isChecked}
                          onChange={() => handleCheckboxToggle(index)}
                        />
                        <span className='capitalize'>
                          {filter?.label ?
                            <>{filter?.label}</>
                            :
                            <>
                              {filter?.name?.includes("_") ? `${filter?.name?.replaceAll("_", " ")}` : filter?.name}
                            </>
                          }
                        </span>

                        <div className={Style.icon}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 15 15" fill="none">
                            <path d="M7.5 1V14M1 7.5H14" stroke="currentColor" strokeWidth="1.18236" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </div>
                      </label>
                    </div>
                  )
                )
              })}
            </div>
          ) : (
            null
          )
        }
      </div>

      {
        filters
          .filter(f => f.isChecked).length ? (
          <div className={Style.modal_footer}>
            <div className={Style.footer_buttons}>
              {/* {returnData?.length > 0 && ( */}
              <button
                className={`${Style.btn} ${Style.outline}`}
                onClick={() => {
                  setSaveFilterName("My Filter")
                  onSave([]); // Clear filters in parent
                  closeFun(); // Optional: Close popup after clearing
                }}
              >
                Clear Filters
              </button>
              {/* )} */}

              <button
                className={`${Style.btn} ${Style.w_100}`}
                onClick={handleSubmit}
                disabled={
                  filters === data
                }
              >
                Apply Filter
              </button>
            </div>
          </div>
        ) : null
      }
    </LeftSidePopupLayout>
  );
};

export default DynamicFilter;
